import type { Store } from 'effector'

import { createStore, sample } from 'effector'
import { features } from '~/core/flags'
import { getCountryCallingCode } from './lib'

// indicates country
export const $detectedCountry: Store<{ country: string }> = features.get(
  'countryLocation',
  { country: 'US' } // `US` by default
)

export const $phoneNumberCountyCode = createStore<string>('')

sample({
  clock: $detectedCountry,
  fn: (location) => getCountryCallingCode(location.country),
  target: $phoneNumberCountyCode,
})
